import React, { useContext } from "react";
import { AuthContext, USER_TYPES } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { canWrite, canAccessAdminPanel } from "../utils/permissions";

export default function Sidebar() {
  const { user, userType, login, logout } = useContext(AuthContext);

  return (
    <div className="w-60 bg-white h-[calc(100vh-4rem)] p-4 border-r
                    flex flex-col fixed top-16 left-0 z-50">
      <nav className="flex-1 space-y-3 text-sm">
        <Link to="/" className="block hover:text-taupe-dark">Home</Link>
        <Link to="/discover" className="block hover:text-taupe-dark">Discover</Link>
        
        {/* Show Write link for journalists and admins */}
        {canWrite(userType) && (
          <Link to="/write" className="block hover:text-taupe-dark">Write</Link>
        )}
        
        {/* Show profile link for logged in users */}
        {userType !== USER_TYPES.ANONYMOUS && (
          <Link to={`/profile/${user.username}`} className="block hover:text-taupe-dark">
            My Profile
          </Link>
        )}
        
        {/* Show bookmarks for logged in users */}
        {userType !== USER_TYPES.ANONYMOUS && (
          <Link to="/bookmarks" className="block hover:text-taupe-dark">
            Bookmarks
          </Link>
        )}
        
        {/* Show admin panel link for admins only */}
        {canAccessAdminPanel(userType) && (
          <Link to="/admin" className="block hover:text-taupe-dark">
            Admin Panel
          </Link>
        )}
      </nav>
      
      {/* User type indicator for development */}
      <div className="mb-4 text-xs text-gray-500">
        {userType === USER_TYPES.ANONYMOUS && "Anonymous User"}
        {userType === USER_TYPES.READER && "Reader"}
        {userType === USER_TYPES.JOURNALIST && "Journalist"}
        {userType === USER_TYPES.ADMIN && "Admin"}
      </div>
      
      {user ? (
        <button
          onClick={logout}
          className="w-full px-3 py-2 bg-taupe text-white rounded-lg hover:bg-taupe-dark text-sm"
        >
          Sign Out
        </button>
      ) : (
        <button
          onClick={login}
          className="w-full px-3 py-2 bg-taupe text-white rounded-lg hover:bg-taupe-dark text-sm"
        >
          Sign In
        </button>
      )}
    </div>
  );
}